var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-desktop': _vm.window.is.desktop, 'is-tablet': _vm.window.is.tablet, 'is-mobile': _vm.window.is.mobile},attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }